import { Layout } from '@arco-design/web-react';
import { Loading } from '../loading';
import { LanguageContext } from '../../utils';
import { useContext, useEffect, useState } from 'react';
import { ExampleFilter } from '../exampleFilter';
import { ExampleGallery } from '../exampleGallery';
import { ExampleGalleryMobile } from '../exampleGallery/mobile';
import { IconMenuFold, IconMenuUnfold } from '@arco-design/web-react/icon';
import { copyWritingsMap } from '../exampleFilter/copywritings';
import { IMetaInfo, Meta, setHeadMeta } from '../meta';

import './index.less';

export function ExampleView(props: {
  data: any;
  siteType: string;
  demoType?: string;
  navigator: React.ReactNode;
  navigatorMobile: React.ReactNode;
  copyWritings: any;
}) {
  const { data, siteType, demoType, navigator, navigatorMobile, copyWritings } =
    props;
  const { language, isMobile } = useContext(LanguageContext);

  const [outlineOpen, setOutlineOpen] = useState<boolean>(false);

  const groupPath = siteType + `${props.demoType ? `-${props.demoType}` : ''}`;

  function getMetaInfo(): IMetaInfo {
    const title = copyWritings.title[language];

    const chartGroups = [
      ...new Set((data ?? []).map((demo) => demo.meta?.group)),
    ];
    const groupString = chartGroups
      .map((group) => copyWritingsMap[groupPath]?.[group]?.[language])
      .filter((string) => !!string)
      .join(', ');
    const description = `${copyWritings.description[language]} ${groupString}`;
    return { title: title, description: description };
  }

  useEffect(() => {
    setHeadMeta(getMetaInfo());
  }, [data, language]);

  if (!data) {
    return (
      <Layout>
        <Layout.Header>{navigator}</Layout.Header>
        <Layout.Content>
          <Loading
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              zIndex: 10,
              background: 'rgba(255, 255, 255, 0.5)',
            }}
          />
        </Layout.Content>
      </Layout>
    );
  }

  const demos = data;

  //demo分组
  const chartGroups = [...new Set(demos.map((demo) => demo.meta?.group))];

  const groupDemos = chartGroups.map((chartGroup) => {
    return {
      group: chartGroup,
      filterDemos: demos.filter((demo) => demo.meta?.group === chartGroup),
    };
  });

  return isMobile ? (
    <Layout style={{ overflow: 'hidden' }}>
      <Meta metaInfo={getMetaInfo()} />
      <div
        style={{
          position: 'fixed',
          left: outlineOpen ? 201 : 0,
          top: 60,
          padding: 8,
          lineHeight: '20px',
          fontSize: '20px',
          borderRadius: '0 4px 4px 0',
          boxShadow: '2px 0 8px #00000026',
          transition: 'left 0.2s',
          zIndex: 100,
          background: '#ffffff',
        }}
        onClick={() => setOutlineOpen(!outlineOpen)}
      >
        {outlineOpen ? <IconMenuFold /> : <IconMenuUnfold />}
      </div>
      <Layout.Sider
        width={outlineOpen ? 201 : 0}
        style={{
          height: '100vh',
          overflowY: 'scroll',
          zIndex: 15,
        }}
      >
        <div className="vchart-example-filter">
          <ExampleFilter
            chartGroups={chartGroups}
            siteType={siteType}
            demoType={demoType}
          />
        </div>
      </Layout.Sider>
      <Layout.Content
        style={{
          minWidth: '100%',
          height: '100vh',
          overflowY: outlineOpen ? 'hidden' : 'scroll',
          overflowX: 'hidden',
        }}
      >
        <div
          style={{
            position: 'fixed',
            width: '100%',
            height: '150%',
            backgroundColor: outlineOpen
              ? 'rgba(0, 0, 0, 0.35)'
              : 'rgba(0, 0, 0, 0)',
            transition: 'background-color 0.3s',
            top: 0,
            zIndex: outlineOpen ? 11 : -1,
          }}
        ></div>
        {navigatorMobile}
        <div
          className="vchart-example-container vchart-example-container-supply"
          style={{
            backgroundColor: '#ffffff',
            padding: '20px 20px 40px 40px',
            minHeight: 'calc(100vh - 48px)',
          }}
        >
          <div className="vchart-example-inner-container-right">
            <ExampleGalleryMobile
              activeIndex={0}
              groupDemos={groupDemos}
              activeKeyword={''}
              demos={demos}
              siteType={siteType}
              demoType={demoType}
            />
          </div>
        </div>
      </Layout.Content>
    </Layout>
  ) : (
    <Layout>
      <Meta metaInfo={getMetaInfo()} />
      <Layout.Header>{navigator}</Layout.Header>
      <Layout
        style={{
          height: 'calc(100vh - 48px)',
          minHeight: 'calc(100vh - 48px)',
          marginTop: '48px',
        }}
        hasSider={true}
      >
        <Layout.Sider>
          <div className="vchart-example-filter">
            <ExampleFilter
              chartGroups={chartGroups}
              siteType={siteType}
              demoType={demoType}
            />
          </div>
        </Layout.Sider>
        <Layout.Content style={{ maxHeight: 'calc(100vh - 48px)' }}>
          <div
            className="vchart-example-container"
            style={{ minHeight: 'calc(100vh - 48px)' }}
          >
            <div
              className="vchart-example-inner-container"
              style={{ padding: '0px 20px 60px 40px' }}
            >
              <ExampleGallery
                activeIndex={0}
                groupDemos={groupDemos}
                activeKeyword={''}
                demos={demos}
                siteType={siteType}
                demoType={demoType}
              />
            </div>
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  );
}
